
// Polyfill per IE11
//https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill

(function(){
    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent (event, params) {
        params = params || {bubbles: false, cancelable: false, detail: null};
        var evt = document.createEvent( 'CustomEvent');
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();


$(document).ready(function(){

    // Menu mobile
    if (window.matchMedia("(max-width: 991px)").matches){
        $('.js-toggleMenu').on('click',function(e){
            e.preventDefault();
            $('header').toggleClass('is-expanded');

            if(!$("body").hasClass('nav-expanded')){
                setTimeout(function(){
                    $('body').addClass('nav-expanded');
                }, 300);
            }
            else{
                $('body').removeClass('nav-expanded');
            }
        });
        //sottomenu
        $('.has-submenu> a').on('click',function(e){
            e.preventDefault();
            $(this).siblings('.submenu').slideToggle('slow');
            $('.has-submenu').toggleClass('is-selected');
        });
    }

    // Menu desktop
    if (window.matchMedia("(min-width: 992px)").matches){

        $('.has-submenu > a').on('click', function(event){
            event.preventDefault();

            var selectedItem = $(this).parent('.has-submenu');

            if(!$(selectedItem).hasClass('is-selected')){
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open').attr('aria-expanded','false');
                selectedItem.addClass('is-selected').children('.submenu').addClass('is-open').attr('aria-expanded','true');
            }

            else{
                selectedItem.removeClass('is-selected').children('.submenu').removeClass('is-open');
            }


        });

        // Lingue
        $('.js-language-toggle').on('click', function(event){
            event.preventDefault();
            $('.language-menu').toggleClass('is-visible');
        });


        $(document).click(function(e) {
            //check if the clicked area is dropDown or not
            if ($('.has-submenu').has(e.target).length === 0) {
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
            }

            if ($('.js-language-toggle').has(e.target).length === 0) {
                $('.language-menu').removeClass('is-visible');
            }
        })

        $(document).keyup(function(e) {

            if (e.keyCode == 27) { // escape key maps to keycode `27`
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
                $('.language-menu').removeClass('is-visible');
            }
        })
    }

// Slider gamma home
        $('.models .product-slider').slick({
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            responsive: [{
                    breakpoint: 2561,
                    settings: {
                        infinite: false,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        infinite: false,
                        slidesToShow: 2,
                        arrows: false
                    }
                },
                {
                    breakpoint: 601,
                    settings: {
                        infinite: false,
                        slidesToShow: 1,
                        arrows: false
                    }
                }
            ]
        });

        // Slider guide home
        $('.handbook-slider').slick({
            infinite: false,
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: true,
            responsive: [{
                    breakpoint: 1900,
                    settings: {
                        infinite: false,
                        slidesToShow: 5,
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        infinite: false,
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1439,
                    settings: {
                        infinite: false,
                        slidesToShow: 4,
                        arrows: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        infinite: false,
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 601,
                    settings: {
                        infinite: false,
                        slidesToShow: 1,
                    }
                }
            ]
        });


// Slider case studies home
        $('.single-slider').slick({
            infinite: false,
            arrows: false, 
            dots: true     
        });


        // Slider blog home
        $('.blog-slider').slick({
            infinite: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false, 
            dots: true, 
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        infinite: false,
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 601,
                    settings: {
                        infinite: false,
                        slidesToShow: 1,
                    }
                }
            ]
        });


        // Slider loghi partner
        $('.partners .multiple-items').slick({
            infinite: true,
            slidesToShow: 8,
            slidesToScroll: 8,
            //autoplay: true,
            //autoplaySpeed: 3000,
            arrows: false,
            dots: true,
            responsive: [{
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });



        // Slider ricambi e accessori
        $('.extras .product-slider').slick({
            infinite: false,
            slidesToShow:4,
            slidesToScroll: 4,
            dots: true,
            arrows: false,
            centerMode: true,
            responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    centerMode: false,
                    dots: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    centerMode: false,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false
                }
            }
            ]
        });


    // Product gallery
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        infinite: false
        //asNavFor: '.slider-nav'
    });

    $('.slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        arrows: false,
        focusOnSelect: true,
        infinite: false,
        centerMode: true,
        variableWidth: true,
        responsive: [{
                breakpoint: 991,
                settings: {
                    centerMode: false
                }
            }
        ]
    });

    

      $('.slider-nav .slick-slide').on('click', function (event) {
        $('.slider-for').slick('slickGoTo', $(this).data('slickIndex'));
    }); 

    $('.videoLightbox').slickLightbox();

   /*  $('.slider-for').slickLightbox({
        navigateByKeyboard : true,
        caption: 'caption'
    });  */

     // Gallery con lightbox
    $('.gallery-slider').slick({
        infinite: false,
        dots: true,
        adaptiveHeight: true,
        responsive: [{
                breakpoint: 767,
                settings: {
                    arrows: false
                }
            }
        ]
    });

    $('.gallery-slider').slickLightbox({
        navigateByKeyboard : true,
        caption: 'caption'
    }); 


    //Accordion
    $('.accordion .accordion__item.accordion__content').show();

    var item = document.querySelectorAll('.accordion__item');
    for(var i = 0; i < item.length; i++) {
        item[i].classList.add('js-item');
    }

    var title = document.querySelectorAll('.accordion__header');
    for(var i = 0; i < title.length; i++) {
        title[i].classList.add('js-header');
    }

    var copy = document.querySelectorAll('.accordion__content');
    for(var i = 0; i < copy.length; i++) {
        copy[i].classList.add('js-content');
    }

    $('.accordion .js-content').slideUp();    
    $('.accordion__item .js-header').attr('aria-expanded','false');

    // Primo elemento aperto
    //$('.accordion .accordion__item:first-child .js-header').toggleClass('active');
    //$('.accordion .accordion__item:first-child .js-content').slideDown();
    //$('.accordion__item:first-child .js-header').attr('aria-expanded','true');



    //var $title = $('.accordion .js-header');

    $('.accordion .js-header').click(function () {
        $(this).next(copy).slideToggle();
        $(this).parent().siblings().children().next().slideUp();
        $(this).toggleClass('active');

        $(this).parent().siblings().children().removeClass('active');


        // toggle attributi
        if($(this).attr('aria-expanded') == 'true'){
            $(this).attr('aria-expanded','false');
        }

        else if($(this).attr('aria-expanded') == 'false'){
            $(this).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
        }

        return false;

    });

    var $item = $('.accordion .js-item'); // per la tastiera ridefinisco il selettore perché è l'item ad essere focusable a differenza del clic del mouse cha va sull'header


    $item.keydown(function(e){ // usare keydown e non keyup perché così si può sovrascrivere il comportamento di default della space-bar che se selezionata fa scrollare la pagina


        var keyCode = e.keyCode || e.which;


        if(keyCode == 13 || keyCode == 32){    // all'invio o alla space-bar


            $(this).children(title).next(copy).slideToggle();
            $(this).siblings().children().next().slideUp();
            $(this).children(title).toggleClass('active');

            $(this).siblings().children().removeClass('active');


            if($(this).children(title).attr('aria-expanded') == 'true'){
                $(this).children(title).attr('aria-expanded','false');
            }

            else if($(this).children(title).attr('aria-expanded') == 'false'){
                $(this).children(title).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
            }

            return false;
        }

    });

    // Ricerca + suggerimenti
    /*
    $("input[type='search']").on('focus', function(){
        $(this).removeAttr('placeholder');
    });

    $(".is-ajax-search input[type='search']").on('focusout', function(){
        $("div.is-ajax-search-result").hide();

    });

    $(".is-ajax-search input[type='search']").on('keyup', function(){
        $(".is-loader-image").show();

        var selected = $(this);

        if(selected.val().length >= 1){
            setTimeout(function() { 
                selected.next(".is-loader-image").hide();
                $("div.is-ajax-search-result").show();
            }
                       , 700);
        }

        else{
            selected.next(".is-loader-image").hide();
            setTimeout(function() { 
                $("div.is-ajax-search-result").hide();    
            }
                       , 700);
        }
    });
    */


// Toggle contenuti extra tabella prodotto
$('.js-more').on('click',function(e){
    console.log('clic');
    e.preventDefault();
    var textVariable = $(this).data("toggletext");          
    $(this).data('toggletext', $(this).text()).text(textVariable);
    $('.moreContent,.tableLegend').slideToggle('slow');
});

// Intersection observer per "accendere" voci menu contestuale

let options = {
    rootMargin: '0px 0px -5% 0px',
    threshold: 0.25
}


let callback = (entries, observer) => {
    entries.forEach(entry => {
        if(entry.isIntersecting){
           $(".stickyMenu a, .contentWrapAside__menu a").removeClass("is-active"); 
           $("a[href$='#"+entry.target.id+"']").addClass("is-active");
           addClass(entry.target);
        }
        else{
            removeClass(entry.target);
        }
    });
};


function addClass(entry) {
    if (!entry.classList.contains('entering')) {
        entry.classList.add('entering');
    }
 
}

function removeClass(entry) {
    if (entry.classList.contains('entering')) {
        entry.classList.remove('entering');
    }
}


let observer = new IntersectionObserver(callback, options);
const entries = [].slice.call(document.querySelectorAll('.toObserve'));
entries.forEach(entry => observer.observe(entry)); 



    // Smooth Anchor scroll with fixed header
    var headerHeight  = $("header").outerHeight();
    var stickyMenuHeight = $(".stickyMenu").outerHeight();
    var custom_offset = headerHeight + stickyMenuHeight + 20;  

    $('.contentWrapAside__menu').on('click','a[href^="#"]',function(event){
        event.preventDefault();
        /* $('a').removeClass('is-active');
        $(this).addClass('is-active'); */
 
        var target_offset = $(this.hash).offset() ? $(this.hash).offset().top : 0;

        $('html, body').animate({
            scrollTop: target_offset - headerHeight - 30
        }, 1000);
    }); 

    $('.stickyMenu').on('click','a[href^="#"]',function(event){
        event.preventDefault();
        /* $('a').removeClass('is-active');
        $(this).addClass('is-active'); */

        var target_offset = $(this.hash).offset() ? $(this.hash).offset().top : 0;
        // to balance fixed header height + sticky menu
        $('html, body').animate({
            scrollTop:target_offset - custom_offset
        }, 1000);
    });

});




